import { useState, useMemo } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { Company } from "@modules/companies/types";
import { useFetchResourcesByIdsQuery } from "@shared/services/queries";
import { ApiResponse } from "@shared/types";
import { Agreement } from "@modules/agreements/types";

export function useCompaniesList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();


  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Company>({
    resource: "v1/company_admin",
    filters: getQueryParams(),
    sorters: { ordering: "-id" },
  });

  const agreementIds = useMemo(
    () => [...new Set(rows?.map((company) => company.agreement).filter((id): id is string => !!id))],
    [rows]
  );

  const { data: agreements } = useFetchResourcesByIdsQuery<ApiResponse<Agreement>>({
    resource: "v1/agreement_admin",
    ids: agreementIds,
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    agreements: agreements?.results,

    refetch,
    setSelectedRows,
    translate,

  };
}
